import { codify, getAnalyticVariable } from '@/utils/analytics';

export function getItineraryTrackingAttributes() {
  return {
    'tl-cruise_id': getAnalyticVariable('cruise_id')?.[0],
    'tl-cruise_name': getAnalyticVariable('cruise_name'),
    'tl-cruise_direction': getAnalyticVariable('cruise_direction'),
    'tl-itinerary_id': getAnalyticVariable('itinerary_id'),
    'tl-itinerary_name': getAnalyticVariable('itinerary_name'),
  };
}

/**
 * @param {string} dayName - day name (no need to codify the value, this does that)
 */
export function getItineraryDayTrackingAttributes(dayName) {
  return {
    ...getItineraryTrackingAttributes(),
    'tl-event': 'day_by_day_view',
    'tl-event_name': 'day_by_day_view',
    'tl-itinerary_day_name': codify(dayName),
  };
}

/**
 * @param {string} dayName - day name (no need to codify the value, this does that)
 */
export function getItineraryLearnMoreTrackingAttributes(dayName) {
  return {
    ...getItineraryTrackingAttributes(),
    'tl-event': 'cta_button_click',
    'tl-event_name': 'cta_button_click',
    'tl-itinerary_day_name': codify(dayName),
    'tl-cta_name': 'learn_more',
    'tl-link_type': 'button',
  };
}
